<template>
  <button class="cw-card" @click="$emit('play', { enrollId: learningObject.enrollId, loId: learningObject.loId })">
    <div class="thumb" :style="thumbStyle">
      <span class="offline-badge">
        <IconMenuDownload />
        <span>OFFLINE</span>
      </span>
      <span v-if="learningObject.duration" class="duration-badge">{{ formatSeconds(learningObject.duration) }}</span>
      <span class="play-overlay">
        <IconPlay />
      </span>
    </div>
    <div v-if="progressPercent > 0" class="cw-progress" aria-hidden="true">
      <div class="cw-progress__fill" :style="{ width: progressPercent + '%', backgroundColor: $theme.primaryColor }"></div>
    </div>
    <div class="meta">
      <p class="course-name" :style="{ color: $theme.primaryColor }">{{ learningObject.courseName }}</p>
      <p class="lo-name">{{ learningObject.name }}</p>
      <p class="time" v-if="learningObject.duration">
        {{ formatSeconds(learningObject.seconds) }} / {{ formatSeconds(learningObject.duration) }}
      </p>
    </div>
  </button>
</template>

<script>
import IconMenuDownload from '@/components/UI/IconMenuDownload.vue';
import IconPlay from '@/components/UI/IconPlay.vue';

function pad(n) { return n < 10 ? '0' + n : '' + n; }

export default {
  name: 'ContinueWatchingCard',
  components: { IconMenuDownload, IconPlay },
  props: {
    learningObject: { type: Object, required: true }
  },
  computed: {
    progressPercent() {
      const { seconds, duration } = this.learningObject;
      if (!duration || !seconds) return 0;
      return Math.min(100, Math.round((seconds / duration) * 100));
    },
    thumbStyle() {
      if (this.learningObject.thumbnail) {
        return { backgroundImage: `url("${this.learningObject.thumbnail}")` };
      }
      // Sem thumb: fallback que adapta ao tema (var setada no root da página).
      return { backgroundColor: 'var(--md-thumb-empty)' };
    }
  },
  methods: {
    formatSeconds(s) {
      const total = Math.max(0, Math.floor(s || 0));
      const m = Math.floor(total / 60);
      const sec = total % 60;
      return `${m}:${pad(sec)}`;
    }
  }
};
</script>

<style scoped lang="scss">
.cw-card {
  flex: 0 0 150px;
  width: 150px;
  text-align: left;
  background: var(--md-surface);
  border: 0.5px solid var(--md-border);
  border-radius: 10px;
  overflow: hidden;
  padding: 0;
  cursor: pointer;
  transition: transform 150ms ease;

  &:active { transform: scale(0.98); }
}

.thumb {
  position: relative;
  height: 84px;
  background-size: cover;
  background-position: center;
}

.offline-badge {
  position: absolute;
  top: 6px;
  left: 6px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 6px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.3px;

  ::v-deep svg { width: 10px; height: 10px; }
}

.duration-badge {
  position: absolute;
  bottom: 6px;
  right: 6px;
  padding: 2px 5px;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  font-size: 10px;
  font-weight: 500;
}

.play-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.55);

  // IconPlay crava :stroke=primaryColor no próprio SVG (não usa currentColor);
  // força branco só aqui, sem tocar no componente compartilhado.
  ::v-deep svg g { stroke: #fff; }
  ::v-deep svg { width: 14px; height: 14px; }
}

// Barra de progresso (estilo YouTube) entre o thumbnail e o texto.
.cw-progress {
  height: 3px;
  background: var(--md-progress-track);
}
.cw-progress__fill {
  height: 100%;
  transition: width 200ms ease;
}

.meta {
  padding: 8px 10px 10px;
}

.course-name {
  margin: 0 0 2px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lo-name {
  margin: 0 0 4px;
  font-size: 12px;
  font-weight: 500;
  color: var(--md-text);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.25;
  min-height: 30px;
}

.time {
  margin: 0;
  font-size: 10px;
  color: var(--md-text-muted);
}
</style>
